export default {
  list(state) {
    return state.serviceTypes;
  },
};
